import t from 'rcm-i18n';
import React from 'react';
import { DownloadVideo } from 'vimeo-popup-player';
import { Category } from './types';

interface Props {
    onClose: () => void;
    category: Category;
}

const CategoryHeader = ({
    onClose,
    category: {imageUrl, label, video},
}: Props) => <div className="category-header-wrapper">
    <div className="category-header" onClick={onClose}>
        <div className="category-icon">
            <img src={imageUrl} />
        </div>
        <div>
            <span className="category-label">{label}</span>
            <DownloadVideo className="btn btn-primary" video={video} />
        </div>
        <div className="category-close">
            <button className="btn btn-primary" onClick={onClose}>
                {t('Back')}
            </button>
        </div>
    </div>
</div>;

export default CategoryHeader;
